<template>
  <div class="books animated fadeIn">
    <div class="body">
      <div class="row">
          <div class="col-md-6 col-6">
             <SidebarView title="Courses" single="true" />
          </div>
          <div class="col-md-6 col-6 text-right">
            <router-link to="/">
            <img src="../assets/images/icon.jpg" class="myicon" />
           </router-link>
        </div>
      </div>
      <br /><br />
      <div class="row">
        <div class="col-md-4 col-sm-6 item-container">
            <a target="_blank" href="https://www.linkedin.com/learning/secure-ai-assisted-development-in-production-practical-guardrails-for-platform-and-devops-teams" class="books-item">
              <div>
                <span>
                    <small>COURSE</small>
                </span>
                <p class="bolder">
                  Secure AI-Assisted Development in Production &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br />
                </p>
                <img src="../assets/images/ai-assissted-dev.png" class="books-thumbnail"/>
              </div>
            </a>
          </div>
        <div class="col-md-4 col-sm-6 item-container">
            <a target="_blank" href="https://learning.oreilly.com/live-events/getting-started-with-aiops/0642572207915/" class="books-item">
              <div>
                <span>
                    <small>COURSE</small>
                </span>
                <p class="bolder">
                  Getting Started with AIOps<br /><br />
                </p>
                <img src="../assets/images/oreilly-3-1.png" class="books-thumbnail"/>
              </div>
            </a>
          </div>
        <div class="col-md-4 col-sm-6 item-container">
            <a target="_blank" href="https://www.oreilly.com/live-events/site-reliability-engineering-sre-and-observability-fundamentals/0642572183424/" class="books-item">
              <div>
                <span>
                    <small>COURSE</small>
                </span>
                <p class="bolder">
                  Site Reliability Engineering (SRE) and Observability Fundamentals<br />
                </p>
                <img src="../assets/images/oreilly-2-1.png" class="books-thumbnail"/>
              </div>
            </a>
          </div>
          <div class="col-md-4 col-sm-6 item-container">
            <a target="_blank" href="https://www.linkedin.com/learning/securing-azure-infrastructure-with-bicep" class="books-item">
              <div>
                <span>
                    <small>COURSE</small>
                </span>
                <p class="bolder">
                  Securing Azure Infrastructure with Bicep<br /><br />
                </p>
                <img src="../assets/images/li-security-2.png" class="books-thumbnail"/>
              </div>
            </a>
          </div>
          <div class="col-md-4 col-sm-6 item-container">
            <a target="_blank" href="https://www.linkedin.com/learning/scaling-azure-deployments-with-bicep" class="books-item">
              <div>
                <span>
                    <small>COURSE</small>
                </span>
                <p class="bolder">
                  Scaling Azure Deployments with Bicep<br /><br />
                </p>
                <img src="../assets/images/li-scaling-2.png" class="books-thumbnail"/>
              </div>
            </a>
          </div>
          <div class="col-md-4 col-sm-6 item-container">
            <a target="_blank" href="https://www.linkedin.com/learning/multicloud-application-infrastructure-as-code-with-pulumi/code-multicloud-infrastructure-with-pulumi" class="books-item">
              <div>
                <span>
                    <small>COURSE</small>
                </span>
                <p class="bolder">
                  Multicloud Application Infrastructure as Code with Pulumi<br />
                </p>
                <img src="../assets/images/linkedin-iac-2.png" class="books-thumbnail"/>
              </div>
            </a>
          </div>
          <div class="col-md-4 col-sm-6 item-container">
            <a target="_blank" href="https://www.oreilly.com/live-events/fundamentals-of-infrastructure-as-code/0642572000089/" class="books-item">
              <div>
                <span>
                    <small>LIVE COURSE</small>
                </span>
                <p class="bolder">
                  Fundamentals of Infrastructure as Code<br /><br />
                </p>
                <img src="../assets/images/iac-oreilly-min-1.png" class="books-thumbnail"/>
              </div>
            </a>
          </div>
          <div class="col-md-4 col-sm-6 item-container">
            <a target="_blank" href="https://www.educative.io/courses/navigating-cloud-engineering-as-a-career-path" class="books-item">
              <div>
                <span>
                    <small>COURSE</small>
                </span>
                <p class="bolder">
                  Cloud Engineering for Beginners<br /><br />
                </p>
                <img src="../assets/images/cloud-course.png" class="books-thumbnail"/>
              </div>
            </a>
          </div>
          <div class="col-md-4 col-sm-6 item-container">
              <a target="_blank" href="https://adorahack.selar.co/iac-course" class="books-item">
              <div>
                <span>
                    <small>COURSE</small>
                </span>
                <p class="bolder">
                    Infrastructure Automation with Azure & GitHub<br /><br />
                </p>
                <img src="../assets/images/iac-course-new-min-1.png" class="books-thumbnail"/>
              </div>
              </a>
          </div>
      </div>
    </div>
    <FooterView />
  </div>
</template>

<script>
import SidebarView from '@/components/SidebarView.vue' 
import FooterView from '@/components/FooterView.vue' 

export default {
    components: { 
        SidebarView,
        FooterView 
    }
}
</script>

<style scoped>
.books{
    width: 100%;
}
.books span{
    color: #df4aa8;
}
.books small{
    font-size: 11px;
}
.books p.bolder{
    font-weight: 400 !important;
    color: black;
}
.books .books-thumbnail{
    width: 100%;
}
.books .books-item{
    text-decoration: none !important;
}
.books .books-item:hover div{
    -webkit-box-shadow: 0px 0px 20px -13px rgba(0,0,0,0.7);
  -moz-box-shadow: 0px 0px 20px -13px rgba(0,0,0,0.7);
  box-shadow: 0px 0px 20px -13px rgba(0,0,0,0.7);
}
.books .books-item div{
    padding: 30px;
      -webkit-box-shadow: 0px 0px 20px -13px rgba(0,0,0,0.3);
  -moz-box-shadow: 0px 0px 20px -13px rgba(0,0,0,0.3);
  box-shadow: 0px 0px 20px -13px rgba(0,0,0,0.3);
  border-radius: 30px;
}
.books .item-container{
  margin-bottom: 40px;
}
</style>
